import axios from 'axios';
import {
	API_ENDPOINTS,
	AppContainer,
	AuthPaneContainer,
	Button,
	checkTheme,
	customToast,
	FormInput,
	getLocalUrl,
	getThemeAuthCover,
	getThemeFromUrl,
	LangContext,
	LargeThemeLogo,
	route,
	Spinner, StringHelpers,
	Themes,
	Title,
	Variants,
} from 'carrier-fe';
import { useContext, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import PartnerPlusLogo from 'carrier-fe/src/images/toshiba_partner_plus.svg';
import { logoStyle } from '../../../Constants';

function ForgotPassword() {
	const { getLangPage } = useContext(LangContext);

	const [searchParams] = useSearchParams();
	const username = searchParams.get('username');

	const [data, setData] = useState({
		username: username || '',
	});
	const [errors, setErrors] = useState<{
		username: string[];
	} | null>(null);

	const [submitting, setSubmitting] = useState<boolean>(false);

	const [lang, setLang] = useState<any>(null);

	useEffect(() => {
		if (lang === null) {
			load();
		}
	}, []);



	useEffect(() => {
		if (submitting) {
			setErrors(null);
			submit();
		}
	}, [submitting]);

	const load = async () => {
		getLangPage('dashboard/forgot_password')
			.then((res: any) => {
				if (typeof res === "undefined" || res === null) {
					setLang([]);
				} else {
					setLang(res);

					document.title = res?.page.title ?? 'Forgot password';
				}
			})
			.catch((err: any) => console.error(err));
	};

	const submit = () => {
		axios
			.post(route(API_ENDPOINTS.AUTH.FORGOT_PASSWORD), data)
			.then((res) => {
				console.log(res)
				customToast({
					title: res.data.message,
					variant: Variants.Success,
				});
			})
			.catch((error: any) => {
				console.log(error)
				if (!!error && !!error.response && !!error.response.data) {
					if (!!error.response.data.message) {

						customToast({
							title: error.response.data.message,
							variant: Variants.Danger,
						});
					}

					if (!!error.response.data.data && !!error.response.data.data.errors) {
						setErrors(error.response.data.data.errors);
					}
				} else {
					console.log(error);
					customToast({
						title: 'An error occurred. Please refresh the page to try again.',
						variant: Variants.Danger,
					});
				}
			})
			.finally(() => setSubmitting(false));
	};

	const handleFieldUpdate = (field: string, value: any) => {
		let cloned: any = structuredClone(data);

		cloned[field] = value;

		setData(cloned);
	};

	const renderButtonTitle = () => {
		if (submitting) {
			return lang?.page.submit_button.submitting || 'Sending...';
		}

		return lang?.page.submit_button.default || 'Send reset email';
	};

	// TODO - Create a branded loading spinner
	if (lang === null) {
		return (
			<div className="d-flex align-items-center vh-100 justify-content-center">
				<Spinner />
			</div>
		);
	}

	return (
		<AppContainer>
			<AuthPaneContainer fillerImage={getLocalUrl() + getThemeAuthCover()} className='text-center' >
				<LargeThemeLogo 
					theme={getThemeFromUrl()} 
					style={logoStyle} 
					includeOriginalViessmannLogo 
					useApplianceToshibaLogo
				/>
				{checkTheme(Themes.Toshiba) && 
					<img 
						src={PartnerPlusLogo} 
						alt="Toshiba Partner Plus logo" 
						className='w-50' 
					/>
				}
				<Title
					title={StringHelpers.title(lang?.page.title || 'Forgot password')}
					className="mb-3 text-center w-100"
				/>
				<FormInput
					type="username"
					label={StringHelpers.title(lang?.fields.username || 'username')}
					name="username"
					value={data.username}
					onChange={(value) => handleFieldUpdate('username', value)}
					errorMessages={!!errors && !!errors.username ? errors.username : null}
					disabled={submitting}
				/>
				<div
					className="d-flex justify-content-end align-items-center mb-5"
					style={{ marginTop: '-1rem' }}
				>
					<Link
						className="text-decoration-none link-dark"
						to="/login"
					>
						{lang?.page.links.login || 'Back to login'}
					</Link>
				</div>
				<Button
					label={renderButtonTitle()}
					onClick={() => setSubmitting(true)}
					variant={Variants.Info}
					className="w-100 justify-content-center mb-3"
					disabled={submitting}
				/>
				{checkTheme(Themes.Viessmann) &&
				<div className="d-flex flex-column justify-content-center align-items-center">
					<Link
						className="text-decoration-none link-dark"
						to="/register"
					>
						{lang?.page.links.register || 'No account? Register here.'}
					</Link>
				</div>}
			</AuthPaneContainer>
		</AppContainer>
	);
}

export default ForgotPassword;
